import { HttpClient } from '@angular/common/http';
import { Component } from '@angular/core';
import { AuthService } from './auth/auth.service';
import { InitResolver } from './init.resolver';
import { PwaService } from './pwa/pwa.service';
import { ChatService, NotificationsService } from './stokker/api';
import { Router } from '@angular/router';
import { routeAnimation } from './route-animation';
import { catchError, of } from 'rxjs';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrl: './app.component.scss',
  animations: [routeAnimation]
})
export class AppComponent {
  imageVersionLabel = 'version: unknown';


  constructor(
    private http: HttpClient,
    private authService: AuthService,
    private init: InitResolver,
    private router: Router,
    private pwa: PwaService,
    private notifications: NotificationsService,
    private chat: ChatService,
  ) {}

  ngOnInit() {
    this.pwa.init();
    this.authService.restoreUser();
    this.authService.checkUserValidity().subscribe(() => {
      this.loadImageVersion();
      this.init.ready();
      this.authService.isAuthenticatedSubject.subscribe(authenticated => {
        if (!authenticated) {
          this.router.navigate(['/login']);
        } else {
          // harang-számláló és push-állapot (egyszer indul, utána magától frissül)
          this.notifications.start();
          // csapatchat: élő kapcsolat + olvasatlan-számláló (csak akinek látható a Chat)
          this.chat.start();
        }
      });
    });

  }

  loadImageVersion() {
    this.http.get<{ image_tag?: string; image_repository?: string }>('version')
      .pipe(catchError(() => of({ image_tag: 'unknown', image_repository: 'unknown' })))
      .subscribe((result) => {
        const tag = (result?.image_tag || 'unknown').trim();
        this.imageVersionLabel = `image: ${tag}`;
      });
  }

  isUserAuthenticated() {
    return this.authService.isAuthenticated();
  }

  prepareRoute(outlet: any) {
    return outlet && outlet.activatedRouteData && outlet.activatedRouteData['animation'];
  }
}
